import createActions from 'utils/redux/createActions'

export default createActions([
	'CHANGE_CATEGORY'
  , 'SWITCH_YELP'
  , 'ADD_RESULTS'
  , 'CLEAR_DATA'
  , 'CHANGE_NEAR'
], { category: 'yelp' })



// WEBPACK FOOTER //
// ./src/actions/yelp.js